import { Navigate } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

/**
 * Admin Protected Route Component
 * Redirects to login if user is not authenticated
 * Redirects to home if user is not an admin
 * Only allows access for users with admin role.
 * Auth is initialized once in main.jsx via bootstrapAuth().
 */
function AdminProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const role = useAuthStore((s) => s.role);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminProtectedRoute;
